(function () {
  'use strict';

  var bootstrap = document.currentScript;
  var fitBuilderPromise = null;
  var adjustmentModalPromise = null;
  var pendingFitOpen = null;

  function loadStyle(url, id) {
    var existing = document.getElementById(id);
    if (existing) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = url;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(url, id) {
    var existing = document.getElementById(id);
    if (existing) {
      if (existing.dataset.jmtLoaded === 'true') return Promise.resolve();
      return new Promise(function (resolve, reject) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.id = id;
      script.src = url;
      script.onload = function () {
        script.dataset.jmtLoaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function reportLoadError(name, error) {
    console.error('Unable to load ' + name + '.', error);
  }

  function fitSource(trigger) {
    if (!trigger) return 'programmatic';
    if (trigger.dataset.sourceContext) return trigger.dataset.sourceContext;
    if (trigger.closest('#jmt-prefbar')) return 'preference_bar';
    if (trigger.closest('.menu-drawer')) return 'mobile_menu';
    if (trigger.closest('[data-jmt-sticky-cta], .jmt-sticky-cta')) return 'sticky_cta';
    return 'fit_guide_link';
  }

  function ensureFitBuilder() {
    if (!fitBuilderPromise) {
      fitBuilderPromise = Promise.all([
        loadStyle(bootstrap.dataset.jmtFitBuilderCss, 'jmt-fit-builder-styles'),
        loadScript(bootstrap.dataset.jmtFitBuilderJs, 'jmt-fit-builder-script')
      ]);
    }
    return fitBuilderPromise;
  }

  function fitOptions(trigger) {
    var options = {};
    if (!trigger || !trigger.hasAttribute('data-jmt-cart-edit')) return options;
    options.context = 'cart';
    try { options.selection = JSON.parse(trigger.getAttribute('data-jmt-selection') || '{}'); } catch (error) { options.selection = {}; }
    options.cartTarget = {
      key: trigger.getAttribute('data-cart-key'),
      handle: trigger.getAttribute('data-product-handle'),
      variantId: trigger.getAttribute('data-variant-id'),
      quantity: trigger.getAttribute('data-quantity'),
      properties: trigger.getAttribute('data-properties')
    };
    return options;
  }

  function requestFitOpen(source, options) {
    if (pendingFitOpen) return pendingFitOpen;

    pendingFitOpen = ensureFitBuilder().then(function () {
      var api = window.JMT_FIT_BUILDER;
      if (!api || api === fitBuilderStub || typeof api.open !== 'function') {
        throw new Error('Fit Builder did not initialize.');
      }
      api.open(source || 'programmatic', options || {});
    }).catch(function (error) {
      reportLoadError('the Fit Builder', error);
    }).finally(function () {
      pendingFitOpen = null;
    });

    return pendingFitOpen;
  }

  function ensureAdjustmentModal() {
    if (!adjustmentModalPromise) {
      adjustmentModalPromise = Promise.all([
        loadStyle(bootstrap.dataset.jmtAdjustmentModalCss, 'jmt-adjustment-modal-styles'),
        loadScript(bootstrap.dataset.jmtAdjustmentModalJs, 'jmt-adjustment-modal-script')
      ]);
    }
    return adjustmentModalPromise;
  }

  function requestAdjustmentOpen(trigger, options) {
    return ensureAdjustmentModal().then(function () {
      var api = window.JMTAdjustmentModal;
      if (!api || api === adjustmentModalStub || typeof api.open !== 'function') {
        throw new Error('Optional Adjustments modal did not initialize.');
      }
      api.open(trigger, options || {});
    }).catch(function (error) {
      reportLoadError('Optional Adjustments', error);
    });
  }

  var fitBuilderStub = {
    open: function (source, options) { return requestFitOpen(source, options); },
    close: function () {}
  };
  var adjustmentModalStub = {
    open: function (trigger, options) { return requestAdjustmentOpen(trigger, options); },
    close: function () {}
  };

  window.JMT_FIT_BUILDER = fitBuilderStub;
  window.JMTAdjustmentModal = adjustmentModalStub;

  document.addEventListener('click', function (event) {
    var adjustmentTrigger = event.target.closest('[data-jmt-adjustment-guide-open], [data-jmt-adjustment-modal-open]');
    if (adjustmentTrigger && window.JMTAdjustmentModal === adjustmentModalStub) {
      event.preventDefault();
      event.stopImmediatePropagation();
      requestAdjustmentOpen(adjustmentTrigger, {
        guideOnly: adjustmentTrigger.hasAttribute('data-jmt-adjustment-guide-open')
      });
      return;
    }

    var fitTrigger = event.target.closest('[data-jmt-fit-builder-open]');
    if (fitTrigger && window.JMT_FIT_BUILDER === fitBuilderStub) {
      event.preventDefault();
      requestFitOpen(fitSource(fitTrigger), fitOptions(fitTrigger));
    }
  }, true);
})();
